export default "878d8c0e6e34655a.svg"